import { Button, Buttons, CancelButton, Form, Field, FormMessage, ModalCard } from '~/components';
import { useApi, useWorkspace } from '~/contexts';
import { useForm } from '~/hooks';
import { emptyStringToNull } from '~/utils';
import { Formik } from 'formik';
import React from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import * as Yup from 'yup';

const P = styled.p`
  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`;

export default function StageCollapseConfirmation({ stage, onClose, onCollapse }) {
  const api = useApi();
  const { workspace } = useWorkspace();
  const [{ status, message, isSubmitting }, form] = useForm();

  async function handleSubmit(values) {
    try {
      form.submit();

      const body = emptyStringToNull({
        ..._.omit(values, ['targetStage']),
        targetOpportunityStageId: values.targetStage?.id ?? null,
      });
      await api.www.workspaces(workspace.id).opportunityStages(stage.id).collapse(body);

      await onCollapse();

      form.done();
    } catch ({ message }) {
      form.error({ message });
    }
  }

  const initialValues = {
    targetStage: null,
  };

  return (
    <ModalCard title="Merge Stage" onClose={onClose}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validateOnBlur={false}
        validateOnChange={false}
        validationSchema={Yup.object().shape({
          targetStage: Yup.object().label('Target Stage').nullable().required(),
        })}>
        {(formik) => {
          return (
            <Form>
              <ModalCard.Body>
                <P>
                  This will merge the <strong>{stage.name}</strong> stage into the selected target stage below. All
                  opportunities in this stage will be moved to the target stage, and <strong>{stage.name}</strong> will
                  be deleted.
                </P>

                <Form.Control>
                  <Field.OpportunityStageSelect
                    name="targetStage"
                    placeholder="Target Stage"
                    opportunityPipelineId={stage.opportunityPipelineId}
                    exclude={[stage.id]}
                    clearable={false}
                  />
                </Form.Control>
                {status && <FormMessage.Error spaceTop>{message}</FormMessage.Error>}
              </ModalCard.Body>
              <ModalCard.Footer>
                <Buttons align="right">
                  <CancelButton onClick={onClose}>Close</CancelButton>
                  <Button onClick={formik.submitForm} isLoading={isSubmitting}>
                    Merge
                  </Button>
                </Buttons>
              </ModalCard.Footer>
            </Form>
          );
        }}
      </Formik>
    </ModalCard>
  );
}
